// React
import React, { useContext, useEffect, useRef, useState } from "react";
// React

// CSS
import styles from "./AddGroupOnGroup.module.css";
// CSS

// Modules
import { useNavigate } from "react-router-dom";
// Modules

// Redux
import { useAppDispatch, useAppSelector } from "../../../app/store";
import {
  editAsyncGroupOnGroup,
  getAsyncAllGroups,
  groupSlice,
} from "../../../Features/GroupSlice/groupSlice";
import { customizedToast } from "../../../Utils/CustomizedToast/customizedToast";
import { Spinner } from "reactstrap";
import Swal from "sweetalert2";
import { BsDashLg } from "react-icons/bs";
import { MdDone } from "react-icons/md";
// Redux

// Contexts
import { IsNightModeOnContext } from "../../../Contexts/IsNightModeOnContext/IsNightModeOnContext";
// Contexts

const AddGroupOnGroup = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const isNightOn = useContext(IsNightModeOnContext);

  const { accessToken: userToken } = useAppSelector((state) => state.loginData);
  const { selectedTenant } = useAppSelector((state) => state.tenants);

  const allGroups = useAppSelector((state) => state.groups.allGroupsData);
  const {
    groupOnGroupAccess: {
      edit: { isDone, isPending },
    },
  } = useAppSelector((state) => state.groups);

  const fromSelectRef = useRef<HTMLSelectElement>(null);
  const toSelectRef = useRef<HTMLSelectElement>(null);

  const initializeData = useRef<{
    fromGroup: string;
    toGroup: string;
    isHegemony: boolean;
  }>({
    fromGroup: "",
    toGroup: "",
    isHegemony: true,
  });
  const [groupsToAdd, setGroupsToAdd] = useState<
    {
      id: number;
      data: {
        fromGroup: string;
        toGroup: string;
        isHegemony: boolean;
      };
    }[]
  >([]);

  useEffect(() => {
    dispatch(
      getAsyncAllGroups({
        userToken,
        _data: {
          page: 1,
          search: "",
          size: 999,
          tenant: selectedTenant.tenantId,
        },
      })
    );
  }, [dispatch, userToken, selectedTenant]);

  useEffect(() => {
    return () => {
      dispatch(groupSlice.actions.resetGroupOnGroupAddingState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (!isDone) return;
    navigate("/groups");
  }, [isDone, navigate]);

  return (
    <div
      className={`${styles.addGroupOnGroupContainer} ${
        isNightOn ? "nightBg1" : ""
      }`}
    >
      {!allGroups.isRecevedGroupsPending ? (
        <div className="w-100 d-flex flex-column align-items-center">
          <div
            className={`${styles.groupsContainer} w-100 d-flex flex-row-reverse align-items-end justify-content-between flex-wrap`}
          >
            <div className={`${styles.selectOptionContainer}  `}>
              <p>مبدا</p>

              {/* <CustomSelectOption2
                getSelectedOption={(data) => {
                  initializeData.current.fromGroup = String(data);
                }}
                initialTitle="یکی را انتخاب کنید"
                initialValue={""}
                options={allGroups.content.map((item) => ({
                  title: item.title,
                  value: item.value,
                }))}
              /> */}

              <select
                className="form-select"
                defaultValue={""}
                onChange={(e) => {
                  initializeData.current.fromGroup = e.target.value;
                }}
                ref={fromSelectRef}
              >
                <option value="">یکی را انتخاب کنید</option>
                {allGroups.content.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.title}
                  </option>
                ))}
              </select>
            </div>
            <div className={`${styles.selectOptionContainer}`}>
              <p>مقصد</p>
              <select
                className="form-select"
                defaultValue={""}
                onChange={(e) => {
                  initializeData.current.toGroup = e.target.value;
                }}
                ref={toSelectRef}
              >
                <option value="">یکی را انتخاب کنید</option>
                {allGroups.content.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.title}
                  </option>
                ))}
              </select>
            </div>

            <div className={`${styles.selectOptionContainer}`}>
              <p>نوع دسترسی</p>
              <select
                className="form-select"
                defaultValue={""}
                onChange={(e) => {
                  initializeData.current.isHegemony =
                    e.target.value === "true" ? true : false;
                }}
                ref={toSelectRef}
              >
                <option value="true">دسترسی سلسه مراتب فعال</option>
                <option value="false">دسترسی سلسه مراتب غیر فعال</option>
              </select>
            </div>
          </div>

          <button
            onClick={() => {
              if (initializeData.current.fromGroup === "") {
                customizedToast("مبدا وارد نشده", "info");
                return;
              }
              if (initializeData.current.toGroup === "") {
                customizedToast("مقصد وارد نشده", "info");
                return;
              }
              if (
                initializeData.current.fromGroup ===
                initializeData.current.toGroup
              ) {
                customizedToast("مبدا و مقصد نمیتواند یکسان باشد", "info");
                return;
              }
              setGroupsToAdd((prevState) => [
                ...prevState,
                {
                  id: Date.now(),
                  data: {
                    fromGroup: initializeData.current.fromGroup,
                    toGroup: initializeData.current.toGroup,
                    isHegemony: initializeData.current.isHegemony,
                  },
                },
              ]);
            }}
            className="operationEvent submitBtn align-self-start my-5"
          >
            افزودن
          </button>
        </div>
      ) : (
        <Spinner />
      )}

      <p
        className={`${styles.selectedItemsName} w-100 d-flex flex-row align-items-center justify-content-end`}
      >
        موارد انتخاب شده
      </p>

      <div
        className={`${styles.groupOnGroupItems} w-100 d-flex flex-column align-items-center `}
      >
        {groupsToAdd.map((item, index) => (
          <div
            key={item.id}
            className={`${styles.groupOnGroupItem}
            ${
              isNightOn ? "nightBg2" : ""
            }  w-100 d-flex flex-row align-items-center justify-content-between`}
          >
            <div className="d-flex flex-row">
              <p>
                <span>از گروه</span>
                &nbsp;
                <span>{item.data.fromGroup}</span>
              </p>
              &nbsp;
              {"->"}
              &nbsp;
              <p>
                <span>به گروه</span>
                &nbsp;
                <span>{item.data.toGroup}</span>
              </p>
              <p
                style={{
                  marginRight: "1rem",
                }}
              >
                سلسله مراتب :
                {item.data.isHegemony ? (
                  <MdDone style={{}} />
                ) : (
                  <BsDashLg style={{}} />
                )}
              </p>
            </div>
            <div className="d-flex flex-row">
              <p
                className="operationEvent editBtn"
                onClick={() => {
                  if (!fromSelectRef.current) return;
                  if (!toSelectRef.current) return;

                  fromSelectRef.current.selectedIndex =
                    allGroups.content
                      .map((_item) => _item.value)
                      .findIndex((_item) => _item === item.data.fromGroup) + 1;

                  toSelectRef.current.selectedIndex =
                    allGroups.content
                      .map((_item) => _item.value)
                      .findIndex((_item) => _item === item.data.toGroup) + 1;

                  initializeData.current.fromGroup =
                    allGroups.content[
                      allGroups.content
                        .map((_item) => _item.value)
                        .findIndex((_item) => _item === item.data.fromGroup)
                    ].value;
                  initializeData.current.toGroup =
                    allGroups.content[
                      allGroups.content
                        .map((_item) => _item.value)
                        .findIndex((_item) => _item === item.data.toGroup)
                    ].value;

                  setGroupsToAdd((prevState) =>
                    prevState.filter((_item) => _item.id !== item.id)
                  );
                }}
              >
                <span className="icon-edit"></span>
              </p>
              <p
                className="operationEvent deleteBtn"
                onClick={() => {
                  Swal.fire({
                    icon: "question",
                    text: "آیا مطمعن هستید ؟",
                    title: "این رابطه حذف شود ؟",
                    showCancelButton: true,
                    cancelButtonText: "لغو",
                    confirmButtonText: "تایید",
                    customClass: isNightOn ? "swalNight" : "",
                  }).then(({ isConfirmed }) => {
                    if (!isConfirmed) return;
                    setGroupsToAdd((prevState) =>
                      prevState.filter((_item) => _item.id !== item.id)
                    );
                  });
                }}
              >
                <span className="icon-trash"></span>
              </p>
            </div>
          </div>
        ))}
      </div>

      <button
        className="operationEvent submitBtn align-self-start mt-3"
        onClick={() => {
          dispatch(
            editAsyncGroupOnGroup({
              userToken,
              _data: {
                tenantId: selectedTenant.tenantId,
                addList: groupsToAdd.map((item) => ({
                  checkingGroupHegemony: item.data.isHegemony,
                  fromGroup: item.data.fromGroup,
                  toGroup: item.data.toGroup,
                })),
                deleteList: [],
                revertCheckingGroupHegemonyList: [],
              },
            })
          );
        }}
      >
        {!isPending ? "تایید" : <Spinner />}
      </button>
    </div>
  );
};

export default AddGroupOnGroup;
